import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import PercentGauge from "./PercentGauge";

// TODO: Upgrade to mui 5 styling system:
const classes = {
    container: {
        display: "flex",
        color: "grey",
        justifyContent: "start",
        marginTop: "10px",
        marginLeft: "20px",
        marginRight: "14px",
    },
    percentContainer: {
        display: "flex",
        justifyContent: "center",
    },
    onlineContainer: {
        display: "flex",
        color: "grey",
        marginTop: "10px",
        marginRight: "20px",
        justifyContent: "end",
    },
    lastUpdateContainer: {
        display: "flex",
        color: "grey",
        justifyContent: "start",
        marginBottom: "10px",
        marginLeft: "20px",
    },
    title: {
        "&.MuiTypography-subtitle1": {
            fontSize: 17,
            fontWeight: 400,
            color: "#7E909A",
        },
    },
    online: {
        "&.MuiTypography-subtitle1": {
            fontSize: 17,
            fontWeight: 300,
            color: "#1C4E80",
        },
    },
    lastUpdated: {
        "&.MuiTypography-body1": {
            fontSize: 14,
            fontWeight: 300,
        },
    },
    background: {
        alignContent: "center",
        height: "auto",
        borderRadius: "20px",
        backgroundColor: "white",
        boxShadow: "#CDCDCD 0px 2px 10px",
        marginBottom: "10px",
    },
};

const OfflineDevice = (props) => {
    return (
        <>
            <Box component={Grid} container sx={classes.background}>
                <Grid sx={classes.container} item xs={4}>
                    <Typography sx={classes.title} variant="subtitle1">
                        {props.device}
                    </Typography>
                </Grid>
                <Grid item sx={classes.onlineContainer} xs={5}>
                    <Typography sx={classes.online} variant="subtitle1">
                        {props.online}/{props.total}
                    </Typography>
                </Grid>
                <Grid item xs={12} sx={classes.percentContainer}>
                    <div id={props.id}>
                        <PercentGauge device={props.device} color={props.color} percent={props.percent}></PercentGauge>
                    </div>
                </Grid>
                <Grid item xs={12} sx={classes.lastUpdateContainer}>
                    <Typography sx={classes.lastUpdated}>{`Updated: ${props.updated
                        .toLocaleString()
                        .replace(",", "")}`}</Typography>
                </Grid>
            </Box>
        </>
    );
};

export default OfflineDevice;
